import { XMarkIcon } from '@heroicons/react/24/outline'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { chipBase, hueClasses } from 'app/lib/chipColors'
import { cn } from 'app/lib/utils'

const badgeVariants = cva(chipBase, {
  variants: {
    color: {
      red: hueClasses.red,
      blue: hueClasses.blue,
      sky: hueClasses.sky,
      danger: hueClasses.warning,
      green: hueClasses.green,
      gray: hueClasses.gray,
      amber: hueClasses.amber,
      // Broken appointments, which contact tags already render in this hue.
      orange: hueClasses.orange,
      purple: hueClasses.purple,
    },
  },
  defaultVariants: {
    color: `gray`,
  },
})

export type BadgeColor = NonNullable<VariantProps<typeof badgeVariants>[`color`]>

export interface BadgeProps extends VariantProps<typeof badgeVariants> {
  label: React.ReactNode
  icon?: React.ReactElement
  onRemove?: () => void
  className?: string
}

function Badge({ label, color, icon, onRemove, className }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ color }), className)}>
      {icon && <span className="flex h-3 w-3 shrink-0 items-center justify-center">{icon}</span>}
      <span className="min-w-0 truncate text-center">{label}</span>
      {onRemove && (
        <button onClick={onRemove} className="shrink-0 opacity-60 transition-opacity hover:opacity-100">
          <XMarkIcon className="h-3 w-3" />
        </button>
      )}
    </span>
  )
}

export { Badge, badgeVariants }
